module.exports = __webpack_public_path__ + "img/sld_LT_1.f2b2f1e9.svg";